import { ref } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  const isLoading = ref(true)

  // Initial app mount - hide loader after delay
  nuxtApp.hook('app:mounted', () => {
    setTimeout(() => {
      isLoading.value = false
    }, 1000)
  })

  // Show loader when page starts loading
  nuxtApp.hook('page:start', () => {
    isLoading.value = true
  })

  // Hide loader when page finishes loading
  nuxtApp.hook('page:finish', () => {
    isLoading.value = false
  })

  return {
    provide: {
      isLoading
    }
  }
})
